import useBbbLocationDeliveryAiSummary from './useLocationDeliveryAiSummary'
import useBbbLocationPurchaseAiSummary from './useLocationPurchaseAiSummary'

export const api = {
  bbbLocationPurchaseAiSummary: useBbbLocationPurchaseAiSummary,
  bbbLocationDeliveryAiSummary: useBbbLocationDeliveryAiSummary,
}
